module.exports = __webpack_public_path__ + "static/media/close-line.7488eda2.svg";